export class DigitalOutputToggleRequestViewModel {
	constructor() {
		this.deviceIds = new Array<string>();
	}
	deviceIds: Array<string>;
	message: string;
	state: boolean;
}